import { Component, OnInit } from '@angular/core';
import { DataService } from "../services/dataservice.service";

@Component({
  selector: 'app-prizes',
  templateUrl: './prizes.component.html',
  styleUrls: ['./prizes.component.css']
})
export class PrizesComponent implements OnInit {

  private intro: string = '';
  private body: string = '';

  constructor(private dataService: DataService) {

    this.dataService.dataServiceArrived.subscribe(
      (data) =>
      {
        this.intro = data.filter((data) => {return data.Type == 'intro-prizes'})[0].Content;
        this.body = data.filter((data) => {return data.Type == 'body-prizes'})[0].Content;
      }
    )
  }

  ngOnInit() {
    this.dataService.getContent()
  }



}



// WEBPACK FOOTER //
// ./src/app/main/prizes/prizes.component.ts